export enum FecAccountMatchType {
  Standard = 'standard',
  CustomLabel = 'custom_label',
  SubAccount = 'sub_account',
  Unknown = 'unknown',
}
